export default __webpack_public_path__ + "static/media/calendar.8bda93b2.svg";